import { Component } from "@angular/core";

@Component({
    templateUrl:'./terms_cons.component.html',
    styleUrls:['./terms_cons.component.scss']
})
export class TermsConsComponent{}